import { styleVariables } from '@lib/common';
import { Skeleton, Space } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var AnnotationType;

(function (AnnotationType) {
  AnnotationType[AnnotationType["Skipped"] = 0] = "Skipped";
  AnnotationType[AnnotationType["FillInBlankOrEssay"] = 1] = "FillInBlankOrEssay";
  AnnotationType[AnnotationType["Correct"] = 2] = "Correct";
  AnnotationType[AnnotationType["Incorrect"] = 3] = "Incorrect";
})(AnnotationType || (AnnotationType = {}));

var QuestionSummariesContainer = styled(Space).withConfig({
  displayName: "question-summariescomponent__QuestionSummariesContainer",
  componentId: "sc-1870b58-0"
})(["width:100%;.ant-space-item{width:19%;}"]);
var QuestionSummaryItem = styled.div.withConfig({
  displayName: "question-summariescomponent__QuestionSummaryItem",
  componentId: "sc-1870b58-1"
})(["--background-color:", ";--accent-color:", ";background:var(--background-color);color:var(--accent-color);border-radius:8px;border:2px solid ", ";transition:border 150ms ease-out;cursor:pointer;padding-block:8px;&:hover{opacity:0.6;}"], function (props) {
  var isNotAnswered = props.isNotAnswered,
      isEssayOrFillInBlank = props.isEssayOrFillInBlank,
      isCorrect = props.isCorrect;

  if (isNotAnswered) {
    return styleVariables.colors.red5;
  }

  if (isEssayOrFillInBlank) {
    return styleVariables.colors.blue1;
  }

  if (isCorrect) {
    return styleVariables.colors.green2;
  }

  return styleVariables.colors.red5;
}, function (props) {
  var isNotAnswered = props.isNotAnswered,
      isEssayOrFillInBlank = props.isEssayOrFillInBlank,
      isCorrect = props.isCorrect;

  if (isNotAnswered) {
    return styleVariables.colors.red3;
  }

  if (isEssayOrFillInBlank) {
    return styleVariables.colors.blue2;
  }

  if (isCorrect) {
    return styleVariables.colors.green1;
  }

  return styleVariables.colors.red3;
}, function (props) {
  var active = props.active,
      theme = props.theme;

  if (active && !theme.media.isMobile) {
    return 'var(--accent-color)';
  }

  return 'transparent';
});
var QuestionIndex = styled.div.withConfig({
  displayName: "question-summariescomponent__QuestionIndex",
  componentId: "sc-1870b58-2"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
var QuestionIndexNumber = styled.label.withConfig({
  displayName: "question-summariescomponent__QuestionIndexNumber",
  componentId: "sc-1870b58-3"
})(["font-size:16px;font-weight:600;cursor:pointer;"]);
export var QuestionSummaries = function QuestionSummaries(props) {
  var questions = props.questions,
      isLoadingQuestions = props.isLoadingQuestions,
      questionAnnotations = props.questionAnnotations,
      onSelectQuestion = props.onSelectQuestion,
      activeIndex = props.activeIndex;

  var renderQuestionSummaries = function renderQuestionSummaries() {
    if (isLoadingQuestions) return /*#__PURE__*/_jsx(Skeleton, {});else {
      return questions.map(function (question, index) {
        switch (questionAnnotations[index]) {
          case AnnotationType.Skipped:
            {
              return /*#__PURE__*/_jsx(QuestionSummaryItem, {
                onClick: function onClick() {
                  return onSelectQuestion(index, question.id.toString(), question.sectionId);
                },
                isNotAnswered: true,
                active: index === activeIndex,
                children: /*#__PURE__*/_jsx(QuestionIndex, {
                  children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                    children: index + 1
                  })
                })
              }, index);
            }

          case AnnotationType.FillInBlankOrEssay:
            {
              return /*#__PURE__*/_jsx(QuestionSummaryItem, {
                onClick: function onClick() {
                  return onSelectQuestion(index, question.id.toString(), question.sectionId);
                },
                isEssayOrFillInBlank: true,
                active: index === activeIndex,
                children: /*#__PURE__*/_jsx(QuestionIndex, {
                  children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                    children: index + 1
                  })
                })
              }, index);
            }

          case AnnotationType.Correct:
            {
              return /*#__PURE__*/_jsx(QuestionSummaryItem, {
                onClick: function onClick() {
                  return onSelectQuestion(index, question.id.toString(), question.sectionId);
                },
                isCorrect: true,
                active: index === activeIndex,
                children: /*#__PURE__*/_jsx(QuestionIndex, {
                  children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                    children: index + 1
                  })
                })
              }, index);
            }

          case AnnotationType.Incorrect:
            {
              return /*#__PURE__*/_jsx(QuestionSummaryItem, {
                onClick: function onClick() {
                  return onSelectQuestion(index, question.id.toString(), question.sectionId);
                },
                active: index === activeIndex,
                children: /*#__PURE__*/_jsx(QuestionIndex, {
                  children: /*#__PURE__*/_jsx(QuestionIndexNumber, {
                    children: index + 1
                  })
                })
              }, index);
            }
        }
      });
    }
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(QuestionSummariesContainer, {
      wrap: true,
      children: renderQuestionSummaries()
    })
  });
};